import Vue from 'vue'
import Router from 'vue-router'
import Nature from '../pages/nature'
import Girlsin from '../pages/girlsin'
import Nude from '../pages/nude'
import Girlsout from '../pages/girlsout'
import About from '../pages/about'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Girlsout
    },
    {
      path: '/nature',
      name: 'Nature',
      component: Nature
    },
    {
      path: '/girls_indoor',
      name: 'GirlsIndoor',
      component: Girlsin
    },
    {
      path: '/girls_outdoor',
      name: 'GirlsOutdoor',
      component: Girlsout
    },
    {
      path: '/nude',
      name: 'Nude',
      component: Nude
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '*',
      component: {template: '<h1 class="white"><br><center>Page not found!</center></h1>'}
    },
    {
      path: '/*',
      component: {template: '<h1 class="white"><br><center>Page not found!</center></h1>'}
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js